import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HelpDocumentsComponent } from './help-documents/help-documents.component';
import { HelpHomeComponent } from './help-home/help-home.component';
import { CreateTicketComponent } from './create-ticket/create-ticket.component';

const routes: Routes = [
    { path: 'help', component: HelpHomeComponent, pathMatch: 'full' },
    { path: 'create-ticket', component: CreateTicketComponent ,pathMatch: 'full'},
    // { path: 'home', component: HelpHomeComponent, pathMatch: 'full' },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class HelpDocsRoutingModule {}
